/* eslint-disable no-param-reassign */
/* eslint-disable camelcase */
/* eslint-disable no-plusplus */
import ExcelJS from "exceljs";

function toCamelCase(str) {
  return str.replace(
    /\w\S*/g,
    (txt) => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
  );
}

const downloadData = (dataProp, officeName) => {
  if (dataProp?.length === 0 || !dataProp) {
    // eslint-disable-next-line no-alert
    alert("No data available to export.");
    return;
  }

  const workbook = new ExcelJS.Workbook();

  // Iterate over each KSA
  dataProp.forEach((ksaData, ksaIndex) => {
    const ksaName = Object.keys(ksaData)[0];
    const ksaSheet = workbook.addWorksheet(ksaName);

    const schoolNameCell = ksaSheet.getCell("A1");
    ksaSheet.mergeCells("A1:I1");
    schoolNameCell.value = officeName;
    schoolNameCell.alignment = { vertical: "middle", horizontal: "center" };
    schoolNameCell.font = { size: 16, bold: true, color: { argb: "FFFFFFFF" } };
    schoolNameCell.border = {
      top: { style: "thick" },
      right: { style: "thick" },
      bottom: { style: "thick" },
      left: { style: "thick" },
    };
    schoolNameCell.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "FF244062" },
    };
    ksaSheet.getRow(1).height = 35;

    const mainHeaderCell = ksaSheet.getCell("A2");
    ksaSheet.mergeCells("A2:I2");
    mainHeaderCell.value = `Key Stage Area ${ksaIndex + 1}`;
    mainHeaderCell.alignment = { vertical: "middle", horizontal: "center" };
    mainHeaderCell.font = { size: 16, bold: true };
    mainHeaderCell.border = {
      top: { style: "thick" },
      right: { style: "thick" },
      bottom: { style: "thick" },
      left: { style: "thick" },
    };
    mainHeaderCell.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "FF92D050" },
    };
    ksaSheet.getRow(2).height = 35;

    // Add headers
    const headerRow = ksaSheet.addRow([
      "Grade Level",
      "Subject",
      "Average MPS",
      "Average SD",
      "Level of Mastery",
      "Least Mastered MPS",
      "Least Mastered Competencies",
      "Average MPS Per Grade",
      "KSA Average",
    ]);

    // Styles for header
    headerRow.values.forEach((value, index) => {
      const cell = ksaSheet.getCell(`${String.fromCharCode(64 + index)}3`);
      cell.alignment = { vertical: "middle", horizontal: "center" };
      cell.border = {
        top: { style: "thin" },
        right: { style: "thin" },
        bottom: { style: "thin" },
        left: { style: "thin" },
      };
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FF92cddc" },
      };
    });

    // font styles and height for header cells
    headerRow.eachCell((cell) => {
      cell.font = { size: 12, bold: true };
    });
    ksaSheet.getRow(3).height = 30;

    const columnWidths = [10, 40, 10, 10, 25, 20, 50, 25, 15];

    // Initialize map to track starting row for each grade level
    const gradeStartRowMap = new Map();

    const KSATotal = ksaData[ksaName].ksaOverallAverage;

    // Iterate over each grade level data
    let rowIndex = 4; // Start from row 3 (after the header row)
    ksaData[ksaName].data.forEach((gradeData) => {
      const gradeLevel = Object.keys(gradeData)[0];
      const camelCaseGradeLevel = toCamelCase(gradeLevel);
      const { overallAvgMPSPerGrade } = gradeData[gradeLevel];
      gradeStartRowMap.set(camelCaseGradeLevel, rowIndex);

      const proficiencyLevelText = (avg) => {
        let proflevel = "";

        if (avg === null) {
          proflevel = null;
        } else if (avg >= 96 && avg <= 100) {
          proflevel = `${avg}\nMastered`;
        } else if (avg >= 86 && avg < 96) {
          proflevel = `${avg}\nClosely Approximating Mastery`;
        } else if (avg >= 66 && avg < 86) {
          proflevel = `${avg}\nMoving Towards Mastery`;
        } else if (avg >= 35 && avg < 66) {
          proflevel = `${avg}\nAverage Mastery`;
        } else if (avg >= 15 && avg < 35) {
          proflevel = `${avg}\nLow Mastery`;
        } else if (avg >= 5 && avg < 15) {
          proflevel = `${avg}\nVery Low Mastery`;
        } else if (avg >= 0 && avg < 5) {
          proflevel = `${avg}\nAbsolutely No Mastery`;
        } else {
          proflevel = null;
        }

        return proflevel;
      };

      const proficiencyLevelTextOnly = (avg) => {
        let proflevel = "";

        if (avg === null) {
          proflevel = null;
        } else if (avg >= 96 && avg <= 100) {
          proflevel = "Mastered";
        } else if (avg >= 86 && avg < 96) {
          proflevel = "Closely Approximating Mastery";
        } else if (avg >= 66 && avg < 86) {
          proflevel = "Moving Towards Mastery";
        } else if (avg >= 35 && avg < 66) {
          proflevel = "Average Mastery";
        } else if (avg >= 15 && avg < 35) {
          proflevel = "Low Mastery";
        } else if (avg >= 5 && avg < 15) {
          proflevel = "Very Low Mastery";
        } else if (avg >= 0 && avg < 5) {
          proflevel = "Absolutely No Mastery";
        } else {
          proflevel = null;
        }

        return proflevel;
      };

      gradeData[gradeLevel]?.data?.forEach((grade) => {
        // if subject has components
        if (grade.componentsData) {
          const rowComponentMainData = [
            camelCaseGradeLevel,
            ` ${grade.subject}`,
            grade.overallAverageMPS,
            grade.overallAverageSD,
            proficiencyLevelTextOnly(grade.overallAverageMPS),
          ];

          const subWithComponents = ksaSheet.addRow(rowComponentMainData);
          rowIndex++;

          subWithComponents.getCell(3).alignment = {
            horizontal: "center",
            vertical: "middle",
          };
          subWithComponents.getCell(3).font = {
            italic: true,
          };
          subWithComponents.getCell(3).font = { size: 12, bold: true };

          subWithComponents.getCell(4).alignment = {
            horizontal: "center",
            vertical: "middle",
          };
          subWithComponents.getCell(4).font = {
            italic: true,
          };
          subWithComponents.font = { bold: true };
          subWithComponents.getCell(4).font = { size: 12, bold: true };
          subWithComponents.getCell(5).alignment = {
            wrapText: true,
            horizontal: "center",
            vertical: "middle",
          };

          subWithComponents.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "FFf2f2f2" },
          };

          grade.componentsData.forEach((data) => {
            const {
              subject,
              overallAverageMPS,
              overallAverageSD,
              mps,
              least_mastered,
            } = data;

            let mpsValues;
            if (mps !== null) {
              mpsValues = mps
                ?.map((item) => Object.values(item).join(": "))
                .join("\n");
            } else {
              mpsValues = null;
            }

            let leastMasteredValues;
            // Extracting values from least_mastered array
            if (least_mastered !== null) {
              leastMasteredValues = least_mastered
                .map((item) => Object.values(item).join(": "))
                .join("\n");
            } else {
              leastMasteredValues = null;
            }

            const rowComponentData = [
              camelCaseGradeLevel,
              `   ${subject}`,
              overallAverageMPS,
              overallAverageSD,
              proficiencyLevelTextOnly(overallAverageMPS),
              mpsValues,
              leastMasteredValues,
              proficiencyLevelText(overallAvgMPSPerGrade),
              proficiencyLevelText(KSATotal),
            ];

            const row = ksaSheet.addRow(rowComponentData);

            row.fill = {
              type: "pattern",
              pattern: "solid",
              fgColor: { argb: "FFf2f2f2" },
            };

            // 2 subject
            // 3 overallAverageMPS
            // 4 overallAverageSD
            // 5 level of mastery
            // 6 mpsValues
            // 7 leastMasteredValues
            // 8 Average MPS Per Grade

            row.getCell(2).alignment = {
              vertical: "middle",
            };

            row.getCell(3).alignment = {
              horizontal: "center",
              vertical: "middle",
            };
            row.getCell(3).font = {
              horizontal: "center",
              vertical: "middle",
              italic: true,
            };

            row.getCell(4).alignment = {
              horizontal: "center",
              vertical: "middle",
            };
            row.getCell(4).font = {
              horizontal: "center",
              vertical: "middle",
              italic: true,
            };

            row.getCell(5).alignment = {
              wrapText: true,
              horizontal: "center",
              vertical: "middle",
            };
            row.getCell(5).font = {
              italic: true,
            };
            row.getCell(6).alignment = {
              wrapText: true,
              horizontal: "center",
              vertical: "middle",
            };
            row.getCell(7).alignment = { wrapText: true, vertical: "middle" };
            row.getCell(8).alignment = {
              wrapText: true,
              horizontal: "center",
              vertical: "middle",
            };

            const rowRange = ksaSheet.getRow(rowIndex);

            rowRange.eachCell({ includeEmpty: true }, (cell) => {
              cell.border = {
                left: { style: "thin" },
                right: { style: "thin" },
              };
            });
            rowIndex++;
          });
        } else {
          const {
            subject,
            overallAverageMPS,
            overallAverageSD,
            mps,
            least_mastered,
          } = grade;

          // Extracting values from mps array
          let mpsValues;
          if (mps !== null) {
            mpsValues = mps
              ?.map((item) => Object.values(item).join(": "))
              .join("\n");
          } else {
            mpsValues = null;
          }

          let leastMasteredValues;
          // Extracting values from least_mastered array
          if (least_mastered !== null) {
            leastMasteredValues = least_mastered
              .map((item) => Object.values(item).join(": "))
              .join("\n");
          } else {
            leastMasteredValues = null;
          }

          const rowData = [
            camelCaseGradeLevel,
            subject,
            overallAverageMPS,
            overallAverageSD,
            proficiencyLevelTextOnly(overallAverageMPS),
            mpsValues,
            leastMasteredValues,
            proficiencyLevelText(overallAvgMPSPerGrade),
            proficiencyLevelText(KSATotal),
          ];

          const row = ksaSheet.addRow(rowData);

          // 2 subject
          // 3 overallAverageMPS
          // 4 overallAverageSD
          // 5 level of mastery
          // 6 mpsValues
          // 7 leastMasteredValues
          // 8 Average MPS Per Grade

          row.getCell(2).alignment = {
            vertical: "middle",
          };

          row.getCell(3).alignment = {
            horizontal: "center",
            vertical: "middle",
          };
          row.getCell(3).font = {
            horizontal: "center",
            vertical: "middle",
            italic: true,
          };

          row.getCell(4).alignment = {
            horizontal: "center",
            vertical: "middle",
          };
          row.getCell(4).font = {
            horizontal: "center",
            vertical: "middle",
            italic: true,
          };

          row.getCell(5).alignment = {
            wrapText: true,
            horizontal: "center",
            vertical: "middle",
          };
          row.getCell(5).font = {
            italic: true,
          };
          row.getCell(6).alignment = {
            wrapText: true,
            horizontal: "center",
            vertical: "middle",
          };
          row.getCell(7).alignment = { wrapText: true, vertical: "middle" };
          row.getCell(8).alignment = {
            wrapText: true,
            horizontal: "center",
            vertical: "middle",
          };

          const rowRange = ksaSheet.getRow(rowIndex);

          rowRange.eachCell({ includeEmpty: true }, (cell) => {
            cell.border = {
              left: { style: "thin" },
              right: { style: "thin" },
            };
          });
          rowIndex++;
        }
      });
    });

    // for merging whole KSA rows for the "KS Average"
    const lastRowIndex = rowIndex - 1;
    const mergeRange = `I4:I${lastRowIndex}`;
    ksaSheet.mergeCells(mergeRange);
    const KSAverageCell = ksaSheet.getCell("I4");
    KSAverageCell.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "FFFFF200" },
    };
    KSAverageCell.font = { size: 14, bold: true };
    KSAverageCell.alignment = {
      wrapText: true,
      horizontal: "center",
      vertical: "middle",
    };

    // Set column widths based on the maximum length of characters
    columnWidths.forEach((width, index) => {
      ksaSheet.getColumn(index + 1).width = width + 6;
    });

    // Merge cells for the Grade Level column
    gradeStartRowMap.forEach((startRow, gradeName) => {
      const subjectsCount = ksaData[ksaName].data.find(
        (gradeData) => Object.keys(gradeData)[0] === gradeName.toLowerCase()
      )[gradeName.toLowerCase()].data?.length;

      const subjects = ksaData[ksaName].data.find(
        (gradeData) => Object.keys(gradeData)[0] === gradeName.toLowerCase()
      )[gradeName.toLowerCase()].data;

      let componentsCount = 0;

      subjects.forEach((subject) => {
        if (subject.componentsData) {
          componentsCount += subject.componentsData.length;
        }
        // if (subject.subject === "MAPEH") {
        //   const filteredComponents = components.filter(
        //     (component) => component.subId === 6
        //   );

        //   componentsCount += filteredComponents.length;
        // } else if (
        //   subject.subject === "Edukasyong Pangtahanan at Pangkabuhayan"
        // ) {
        //   const filteredComponents = components.filter(
        //     (component) => component.subId === 8
        //   );

        //   componentsCount += filteredComponents.length;
        // } else if (subject.subject === "Technology and Livelihood Education") {
        //   let filteredComponents;

        //   if (gradeName.toLowerCase() === "grade 6") {
        //     filteredComponents = components.filter(
        //       (component) => component.subId === 8
        //     );
        //   } else {
        //     filteredComponents = components.filter(
        //       (component) => component.subId === 9
        //     );
        //   }

        //   componentsCount += filteredComponents.length;
        // }
      });

      const endRow = startRow + subjectsCount + componentsCount - 1;
      const gradeRange = `A${startRow}:A${endRow}`;
      const totalAvgRange = `H${startRow}:H${endRow}`;
      ksaSheet.mergeCells(gradeRange);
      ksaSheet.mergeCells(totalAvgRange);

      for (let i = startRow; i <= endRow; i++) {
        for (let j = 1; j <= 9; j++) {
          // border for 9 columns
          const cell = ksaSheet.getCell(`${String.fromCharCode(64 + j)}${i}`);
          cell.border = {
            top: { style: "thin" },
            left: { style: "thin" },
            bottom: { style: "thin" },
            right: { style: "thin" },
          };
        }
      }

      // Apply top border to the first row of each grade data
      ksaSheet.getRow(startRow).eachCell({ includeEmpty: true }, (cell) => {
        cell.border = {
          ...cell.border,
          top: { style: "medium" },
        };
      });

      // Apply bottom border to the last row of each grade data
      ksaSheet.getRow(endRow).eachCell({ includeEmpty: true }, (cell) => {
        cell.border = {
          ...cell.border,
          bottom: { style: "medium" },
        };
      });

      // Get the merged cell and set the grade level's data alignment to center
      const mergedCell = ksaSheet.getCell(`A${startRow}`);
      const totalMPSAvgmergedCell = ksaSheet.getCell(`F${startRow}`);
      mergedCell.alignment = { vertical: "middle", horizontal: "center" };
      totalMPSAvgmergedCell.alignment = {
        wrapText: true,
        vertical: "middle",
        horizontal: "center",
      };
    });
  });

  const date = new Date();
  const options = { month: "2-digit", day: "2-digit", year: "numeric" };
  const formattedDate = date
    .toLocaleDateString("en-US", options)
    .replace(/\//g, "-");

  const getAbbreviation = (name) => {
    const words = name.split(" ");
    const initials = words.map((word) => {
      if (word.toLowerCase() === "alapan") {
        return `${toCamelCase(word)}`;
      }
      if (word.toLowerCase() === "anabu") {
        return `${toCamelCase(word)}`;
      }
      if (word.toLowerCase() === "palico") {
        return `${toCamelCase(word)}`;
      }
      if (word.toLowerCase() === "tinabunan") {
        return `${toCamelCase(word)}`;
      }
      if (word.toLowerCase() === "toclong") {
        return `${toCamelCase(word)}`;
      }
      if (word.toUpperCase() === "I") {
        return `-${word.toUpperCase()}-`;
      }
      if (word.charAt(0).toUpperCase() === "I") {
        if (word.charAt(1).toUpperCase() === "I") {
          return `-${word.toUpperCase()}-`;
        }
      }
      return word.charAt(0).toUpperCase();
    });
    return initials.join("");
  };

  const filename = `${
    officeName ? `${getAbbreviation(officeName)}_` : ""
  }Overall_Data_Report_${formattedDate}.xlsx`;

  workbook.xlsx.writeBuffer().then((buffer) => {
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
      // For IE browser
      window.navigator.msSaveOrOpenBlob(blob, filename);
    } else {
      // For other browsers
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = filename;
      link.click();
      window.URL.revokeObjectURL(url);
    }
  });
};

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  downloadData,
};
